import { FC } from 'react';
import { HStack, VStack } from '@chakra-ui/react';
import { IconName } from '@shinetools/sunshine-icons';

import Text from 'components/_core/Text';

import { ItemIcon } from '../../../TransactionAggregationTable/components/TransactionAggregationItem/components/ItemPicture';

const InfoBlock: FC<{
  iconName: IconName;
  title: string;
  description: string | JSX.Element;
}> = ({ description, iconName, title }) => {
  return (
    <HStack spacing="space-16" width="100%">
      <ItemIcon color="grey.800" icon={iconName} size="icon-20" />

      <VStack
        alignItems="flexStart"
        justifyContent="flexStart"
        spacing="space-0"
      >
        <Text color="grey.800" fontSize="font-15" fontWeight="weight-500">
          {title}
        </Text>

        <Text fontSize="font-13">{description}</Text>
      </VStack>
    </HStack>
  );
};

export default InfoBlock;
